import { Box, Button, Text } from '@mantine/core';
import classes from './MobileNavBar.module.css';
import { MyIcon } from '@web/common-ui';
import { useWindowSize } from '../../../../../hooks';

export const MobileNavItem = ({
  iconName,
  text,
  route,
  onClick,
}: {
  iconName: string;
  text: string | JSX.Element;
  route: string;
  onClick?: () => void;
}) => {
  const isCurrentRoute = route === window.location.pathname;
  const foreGroundColor = isCurrentRoute ? '#fff' : '#202020';
  const isSmallScreen = useWindowSize(500);
  return (
    <Box p="0px 5px">
      <Button
        className={classes.button}
        variant="white"
        justify="flex-start"
        size="lg"
        w={isCurrentRoute ? 'fit-content' : isSmallScreen ? '40px' : '50px'}
        leftSection={
          <MyIcon
            name={iconName}
            className={classes.icon}
            style={{ fill: foreGroundColor }}
          />
        }
        onClick={onClick}
        bg={isCurrentRoute ? '#202020' : '#F7F6F1'}
      >
        <Text className={classes.navBtnText} style={{ color: foreGroundColor }}>
          {text}
        </Text>
      </Button>
    </Box>
  );
};
